import { styled, keyframes } from '@mui/system';
import { List } from '@mui/material';

const blink = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`;

export const StyledList = styled(List, {
  shouldForwardProp: prop => prop !== 'loading'
})(({ loading }) => ({
  ...(loading && {
    '& > div': {
      filter: 'blur(5px)',
      animation: `${blink} 1s alternate infinite linear`
    }
  })
}));
